// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"07f79441","200":"4377bc2b","453":"bc1e539b","674":"fe64d521","781":"78697e44"}[chunkId] + ".chunk.js";
};